import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class StaticPageEndpoint extends BaseEndpoint {}
